import logo from '../asset/logo.jpg'

const MAP_URL = 'https://www.google.com/maps/place/Main+Campus+Great+Grace+International+Christian+Academy+Along+Rukuba+Barracks+road+Agingi,+Bassa,+Nigeria/@9.8688934,8.856251,17z';

export default function Footer() {
	return (
		<footer className="border-t border-slate-200 bg-slate-50">
			<div className="container-gg py-10">
				<div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
					<div>
						<div className="flex items-center gap-2">
							<img src={logo} alt="GreatGrace" className="h-8 w-8" />
							<span className="font-bold">Great Grace International Christian Academy</span>
						</div>
						<p className="mt-3 text-sm text-slate-600">Excellence in academics and character. Nursery, Primary, and Secondary education.</p>
					</div>
					<div>
						<p className="font-semibold">Explore</p>
						<ul className="mt-3 space-y-2 text-sm text-slate-700">
							<li><a href="/about">About</a></li>
							<li><a href="/academics">Academics</a></li>
							<li><a href="/admissions">Admissions</a></li>
							<li><a href="/contact">Contact</a></li>
						</ul>
					</div>
					<div>
						<p className="font-semibold">Campuse</p>
						<a
							href={MAP_URL}
							className="mt-3 block text-left text-sm text-slate-600 underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
						>
							Main Campus, Great Grace International Christian Academy Along Rukuba Barracks road Agingi, Bassa, Nigeria.
							<span className="block text-xs text-slate-500">Tap to view on map</span>
						</a>
						<a
							href="/"
							className="mt-2 inline-block text-xs font-semibold text-slate-700 underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
						>
							Back to home
						</a>
					</div>
					<div>
						<p className="font-semibold">Contact</p>
						<p className="mt-3 text-sm text-slate-600">Email: greatgraceinternationalchristi@gmail.com<br/>Phone: +234-915 890 0059</p>
					</div>
				</div>
				<p className="mt-10 text-center text-xs text-slate-500">© {new Date().getFullYear()} Great Grace International Christian Academy. All rights reserved.</p>
			</div>
		</footer>
	)
}







